export default __webpack_public_path__ + "static/media/touch.65d1d745.png";